import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  baseUrl = `${this.env.URL_API}/rol`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(private http: HttpClient, private env: EnvService) { }

  createRol(rol): Observable<any> {
    const url = this.baseUrl;
    // console.log(rol);

    return this.http.post(url, rol);
  }

  getRoles() {
    return this.http.get(`${this.baseUrl}`);
  }

  getRol(id): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get(url, { headers: this.headers });
  }

  updateRol(id, rol): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    // console.log(rol);

    return this.http
      .put(url, rol, { headers: this.headers });
  }

  deleteRol(id, id_usuarios_creador): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    const httpOptions = {
      headers: this.headers,
      body: { id_usuarios_creador },
    };
    return this.http
      .delete(url, httpOptions);
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }
}
